/**
 * @generated SignedSource<<d7fd95942480ca34eddc2cdd2edcd4c3>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type StartContentNodeInput = {
  clientMutationId?: string | null;
  contentNodeId: string;
};
export type useGenerateContentSubmission_StartContentNodeMutation$variables = {
  input: StartContentNodeInput;
};
export type useGenerateContentSubmission_StartContentNodeMutation$data = {
  readonly LearnV2: {
    readonly startContentNode: {
      readonly contentSubmission: {
        readonly id: string;
      };
    } | null;
  };
};
export type useGenerateContentSubmission_StartContentNodeMutation = {
  response: useGenerateContentSubmission_StartContentNodeMutation$data;
  variables: useGenerateContentSubmission_StartContentNodeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "LearnV2Mutations",
    "kind": "LinkedField",
    "name": "LearnV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "StartContentNodePayload",
        "kind": "LinkedField",
        "name": "startContentNode",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentSubmission",
            "kind": "LinkedField",
            "name": "contentSubmission",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useGenerateContentSubmission_StartContentNodeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useGenerateContentSubmission_StartContentNodeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "972004c8de51f44bb67ae19286b4b0d6",
    "id": null,
    "metadata": {},
    "name": "useGenerateContentSubmission_StartContentNodeMutation",
    "operationKind": "mutation",
    "text": "mutation useGenerateContentSubmission_StartContentNodeMutation(\n  $input: StartContentNodeInput!\n) {\n  LearnV2 {\n    startContentNode(input: $input) {\n      contentSubmission {\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "92719f29bfef954958bca839563cded1";

export default node;
